import React from "react";
import { IMusic } from "../../../common/commonTypes";
import AboutPhoto from "../../../common/components/AboutPhoto/AboutPhoto";
import defaultAboutPhoto from "../../../../public/images/track-about.jpeg";
import { IMAGE_SIZES } from "../../../constants/imageSizes";

interface IProps {
  music: IMusic;
}

const MusicAbout = ({ music }: IProps) => (
  <AboutPhoto
    description={music?.description}
    photoUrl={music?.poster?.url}
    defaultPhotoUrl={defaultAboutPhoto}
    resizeWidth={IMAGE_SIZES.trackPoster.medium}
  />
);

export default MusicAbout;
